import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router'
import { ROLE_PUBLIC } from '@router/Routes'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'
import useHtmlRenderer from '@hook/useHtmlRenderer'
import { useEffect } from 'react'
import { get } from '@util/xhrAPI'
import { updateCurrentPage } from '@store/slice/mainSlice'
import { useTranslation } from 'react-i18next'

const Page = () => {
  const { slug } = useParams()
  const { mission, currentPage } = useSelector(state => state.main)
  const renderHtml = useHtmlRenderer()
  const navigate = useNavigate()
  const [t] = useTranslation('common')
  const { title, description } = currentPage || {}
  const dispatch = useDispatch()

  useEffect(() => {
    get(`${import.meta.env.VITE_API_URL}/public/missions/${mission.id}/pages/${slug}`, response => {
      const { code, page } = response
      if (200 !== code) {
        navigate(ROLE_PUBLIC['home'])
      }
      dispatch(updateCurrentPage(page))
    })
  }, [])

  return (
    <Div cssClass='cms-page'>
      <h2 className='zone-title'>{title}</h2>
      <Div cssClass='page-text'>
        {currentPage && renderHtml(description)}
      </Div>
      <Div cssClass='actions-zone'>
        <Buttons buttons={[
          { cssClass: 'is-success confirmation-back-home is-rounded', callback: () => navigate(ROLE_PUBLIC['home']), text: t('actions.go_home') },
        ]} />
      </Div>
    </Div>
  )
}

export default Page